// extracted by mini-css-extract-plugin
export default {"banner":"styles_banner__+Er8D","message":"styles_message__Yius2"};